import { apiClient } from './client';
import type { Supplier } from '@/types/oscar';

/**
 * Search the OnsiteCore supplier/creditor master (oscar.vSupplier) by name.
 * Backs the contract Vendor picker — server-side search, capped at 20 rows.
 */
export function searchSuppliers(q: string, signal?: AbortSignal): Promise<Supplier[]> {
  return apiClient.get<Supplier[]>(`/api/suppliers?q=${encodeURIComponent(q)}`, signal);
}
